// import _ from 'lodash';
const axios = require('axios')

// triple i 相關 api
const needsAnalysisRequest = axios.create({baseURL: `https://3i-life.com.tw`});
// 買保險 api
const SbNeedsAnalysisRequest = axios.create({baseURL: ``});


// need_analysis
export const getSbScenarioSurvey = data => SbNeedsAnalysisRequest.get('/api/sb/need_analysis_survey_get', {params:data})
export const postSBResultApi = data => SbNeedsAnalysisRequest.post('/api/v2/sb/need_analysis_result_save', data)
export const getSBResultApi = data => SbNeedsAnalysisRequest.get(`/api/v2/sb/need_analysis_result_get/${data}`)
export const updateSBResultApi = data => SbNeedsAnalysisRequest.post(`/api/v2/sb/need_analysis_result_update`, data)


// retire
// export const getNeedsAnalysisApi = data => needsAnalysisRequest.get('/product/calculationRetire', {params:data});
export const getNeedsAnalysisApi = data => needsAnalysisRequest.get('/product/calculation-retire-api', {params:data});
export const postSbNeedsAnalysisApi = data => SbNeedsAnalysisRequest.post('/api/sb/need_analysis_result_save', data);

export const getSbNeedsAnalysisApi = data => SbNeedsAnalysisRequest.get(`/api/sb/need_analysis_result_get/${data}`);
export const updateSbNeedsAnalysisApi = data => SbNeedsAnalysisRequest.post(`/api/sb/need_analysis_result_update`, data);

// buyHouse
export const getTripleIResultApi = data => needsAnalysisRequest.get('/product/cal-api', {params:data})
export const getSBBuildingAverageApi = data => SbNeedsAnalysisRequest.get('/api/real_estate_actual_price_record', {params:data})
export const getSBCombinePremiumApi = data => SbNeedsAnalysisRequest.get('/api/sb/combineA/premium', {params:data})

// eductionFund
export const postSBEductionFundResultDataApi = data => SbNeedsAnalysisRequest.post('/api/calc_education_fund', data)




